import { formatDate } from 'lib/helpers/dateUtils';

import Avatar from 'components/shared/Avatar/Avatar';
import Dot from 'components/shared/Dot/Dot';
import Icon from 'components/shared/Icon/Icon';
import Typography from 'components/shared/Typography/Typography';

const formatLocation = (location) => {
  if (!location) return '';
  return location.replace(/_/g, '-').replace(/^./, (str) => str.toUpperCase());
};

const DetailItem = ({ icon, value, color = 'neutral' }) => {
  return (
    <div className="flex items-center gap-1">
      {icon && <Icon icon={icon} size={16} color={color} shadow={700} />}
      <Typography variant="p" size="xs" weight="medium" color="neutral-700">
        {value}
      </Typography>
    </div>
  );
};

const UpcomingAppointment = ({ appointment, timezone }) => {
  return (
    <div className=" flex h-[110px] w-fit max-w-full flex-1 items-start gap-3 rounded-md border border-solid border-neutral-200 bg-white px-3 py-2.5 md:max-w-[330px]">
      <div className="flex flex-col justify-center gap-2">
        <div className="flex items-center gap-1.5">
          <Avatar
            size="large"
            fullName={appointment?.practitioner?.fullName}
            id={appointment?.practitioner?.id}
          />
          <div className="flex flex-col justify-center">
            <Typography
              variant="p"
              size="small"
              weight="medium"
              color="neutral-800"
              className="whitespace-nowrap">
              {appointment?.practitioner?.title && `${appointment?.practitioner?.title} `}
              {appointment?.practitioner?.fullName}
            </Typography>
            {appointment?.practitioner?.profession && (
              <div className="h-4">
                <Typography
                  variant="p"
                  size="small"
                  weight="normal"
                  color="neutral-700"
                  className="whitespace-nowrap">
                  {appointment?.practitioner?.profession}
                </Typography>
              </div>
            )}
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-1.5">
          <div className="whitespace-nowrap">
            <DetailItem icon="calendar-mono" value={formatDate(appointment?.starts_at, timezone)} />
          </div>
          <Dot size="xs" color="neutral" />
          <div className="whitespace-nowrap">
            <DetailItem value={formatDate(appointment?.starts_at, timezone, 'h:mm a')} />
          </div>
          {appointment?.location && (
            <>
              <Dot size="xs" color="neutral" />
              <div className="whitespace-nowrap">
                <DetailItem icon="users-mono" value={formatLocation(appointment?.location)} />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default UpcomingAppointment;
